import { render, staticRenderFns } from "./ChildProductsTable.vue?vue&type=template&id=7a2e0041"
import script from "./ChildProductsTable.vue?vue&type=script&lang=js"
export * from "./ChildProductsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports